module.exports = __webpack_public_path__ + "img/ic_notes_active.7d473587.svg";